import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Main as MainTemp } from '../../Styles/Styles';
import { Media } from '../../Resources/Stylesheets/Variables';
import Header from '../../Components/Header/Header';
import { cap, formatPrice } from '../../Library/Library';
import Card, { CardButton } from '../../Components/Card/Card';

const Main = styled(MainTemp)`
  display: grid;
  grid-auto-rows: max-content;
  grid-gap: 30px;
`;

const Container = styled.div`
  display: grid;
  grid-auto-flow: row dense;
  grid-template-columns: repeat(auto-fill, 250px);
  grid-template-rows: repeat(auto-fill, 350px);
  grid-auto-columns: 225px;
  grid-auto-rows: 325px;
  grid-gap: 30px;
  @media (max-width: ${Media.phone}) {
    grid-template-columns: repeat(auto-fill, 100%);
    grid-template-rows: repeat(auto-fill, 1fr);
    grid-auto-columns: 100%;
    grid-auto-rows: 1fr;
  }
`;

const Conferences = () => {
  const conferences = useSelector(state => state.products.conferences);
  const vat = useSelector(state => state.settings.conference.vat);
  const [search, setSearch] = useState('');

  const filteredConferences = conferences
    .filter(e => e.active && `${e.name.toLowerCase()}`.includes(search))
    .map(e => (
      <Card
        key={e.id}
        image={e.image}
        name={cap(e.name)}
        rows={[
          { icon: 'icon-users', label: 'Storlek', value: `${e.spec.size} st` },
          { icon: 'icon-tags', label: 'Timpris', value: `${formatPrice(e.spec.hour, vat)} kr` },
          { icon: 'icon-tags', label: 'Dagspris', value: `${formatPrice(e.spec.day, vat)} kr` }
        ]}
        details={[e.tv && 'icon-tv', e.wifi && 'icon-wifi']}
        button={<CardButton value={<i className="icon-angle-right" />} to={`/conferences/${e.id}`} />}
      />
    ));

  return (
    <Main>
      <Header title="Konferensrum" search={setSearch} />
      {filteredConferences.length > 0 && <Container>{filteredConferences}</Container>}
      {filteredConferences.length === 0 && search !== '' && <p>{`Hittade inga konferensrum för: ${search}`}</p>}
      {filteredConferences.length === 0 && search === '' && <p>Det finns inga aktiva konferensrum.</p>}
      <Container />
    </Main>
  );
};

export default Conferences;
